import React from 'react'
import { useStyles } from './AccueilStyle'
import { Link } from 'react-router-dom'
import img from '../../assets/images/banner.jpg'

//Material UI
import Card from '@material-ui/core/Card'
import SportsTennisIcon from '@material-ui/icons/SportsTennis'
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import ProfessorGrid from "../../components/ProfessorGrid/ProfessorGrid";
import Button from "@mui/material/Button";

export default function Accueil() {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <section className={classes.sectionHome}>
        <Card className={classes.card} style={{ backgroundImage: `url(${img})` }}>
          <div className={classes.text} >
            <div>
              <h1 style={{ width: '100%', textAlign: 'center', color: 'white' }}>
                Bienvenue sur le site AnimaNice.
              </h1>
              <p>
                Vos centres AnimaNice vous accueillent toute l'année aux quatre coins de Nice et proposent des activités culturelles et de loisirs à toutes les générations. Quatre salles de spectacles, la Black Box, le Théâtre de la Tour, l’Espace Grappelli et Lou Mesclun complètent ce réseau.
              </p>

              <Button variant="contained" color="primary">
                <a href="#professeurs" style={{ textDecoration: 'none', color: 'white' }}>
                  Voir la liste des professeurs
                </a>
              </Button>
            </div>
          </div>


          <div className={classes.links}>
            <Link to="/donnees-personnelles">
              <div>
                <AccountCircleIcon />
                <div>
                  <h3>Consultez</h3>
                  <h4>vos données personnelles</h4>
                </div>
              </div>
            </Link>
            <Link to="/souscription">
              <div>
                <AddCircleOutlineIcon />
                <div>
                  <h3>Souscrivez</h3>
                  <h4>à un abonnement</h4>
                </div>
              </div>

            </Link>
            <Link to="/reservation-tennis">
              <div>
                <SportsTennisIcon fontSize="large" />
                <div>
                  <h3>Reservez</h3>
                  <h4>un court de tennis</h4>
                </div>
              </div>

            </Link>
            <Link to="/rendez-vous">
              <div>
                <CalendarTodayIcon fontSize="large" />
                <div>
                  <h3>Rendez-vous</h3>
                  <h4>Prise de rendez-vous</h4>
                </div>
              </div>

            </Link>
          </div>
        </Card>
      </section>
      <ProfessorGrid />
    </div>
  )
}

